import { FunnelConfig } from '~/utils/funnels';
import { store } from '~/utils/store';

export const PARTNER_PROVIDED = 'partner_provided';
export const BILL_CAPTURE = 'bill_capture';

export const config: FunnelConfig = {
  id: 'resuming',
  path: '/resuming',
  show: () => !!store.get('TOKEN'),
};
